import { IResetPasswordDTO } from '@/models/auth.model';
import { AuthFieldsNames, TResetPasswordFormValues } from '../helpers/types';

class ResetPasswordDTO implements IResetPasswordDTO {
  code: string;
  newPassword: string;
  session: string;

  constructor(values: TResetPasswordFormValues, code: string, session: string) {
    this.code = code;
    this.session = session;
    this.newPassword = values[AuthFieldsNames.NEW_PASSWORD];
  }
}

export default ResetPasswordDTO;
